"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SystemAlertBanner = /*#__PURE__*/function (_Component) {
  _inherits(SystemAlertBanner, _Component);
  var _super = _createSuper(SystemAlertBanner);
  function SystemAlertBanner(props) {
    var _this;
    _classCallCheck(this, SystemAlertBanner);
    _this = _super.call(this, props);
    _this.hideSystemAlertBanner = _this.hideSystemAlertBanner.bind(_assertThisInitialized(_this));
    _this.state = {
      hideBanner: false
    };
    return _this;
  }
  _createClass(SystemAlertBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        currentUser = _this$props.currentUser,
        messageId = _this$props.messageId;
      var id = currentUser.id;

      // grab systemAlerts out of localStorage
      var systemAlerts = localStorage.getItem('systemAlerts');
      if (systemAlerts) {
        // don't try to parse a null, bad things happen
        var parsedAlerts = JSON.parse(systemAlerts);

        // check to see if there is a key for the current user
        // in systemAlerts that contains the message id
        if (parsedAlerts[id] && parsedAlerts[id].includes(messageId)) {
          // hide the message

          this.hideSystemAlertBanner();
        }
      }
    }
  }, {
    key: "hideSystemAlertBanner",
    value: function hideSystemAlertBanner() {
      var _this$props2 = this.props,
        currentUser = _this$props2.currentUser,
        messageId = _this$props2.messageId;
      var id = currentUser.id;
      var systemAlerts = localStorage.getItem('systemAlerts');
      // get existing systemAlerts out of localStorage and parse if exists

      var parsedAlerts = systemAlerts ? JSON.parse(systemAlerts) : {};

      // get current user's existing hidden system alerts
      var hiddenAlerts = parsedAlerts[id] || [];

      // create new system alerts object including current user and message id
      var newSystemAlerts = _objectSpread(_objectSpread({}, parsedAlerts), {}, _defineProperty({}, id, _toConsumableArray(new Set([].concat(_toConsumableArray(hiddenAlerts), [messageId])))));

      // hide the banner
      this.setState({
        hideBanner: true
      });

      // add message id to systemAlerts and stick back in localStorage
      localStorage.setItem('systemAlerts', JSON.stringify(newSystemAlerts));
    }
  }, {
    key: "render",
    value: function render() {
      var text = this.props.text;
      var hideBanner = this.state.hideBanner;
      if (hideBanner) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "system-alert-banner"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "system-alert-banner__icon"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        color: "#2C405A",
        icon: "IconInfoCircle",
        size: 28
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "system-alert-banner__text-container"
      }, text), /*#__PURE__*/_react["default"].createElement("div", {
        className: "system-alert-banner__dismiss-container"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "system-alert-banner__dismiss",
        id: "system-alert-banner-dismiss-btn",
        type: "button",
        onClick: this.hideSystemAlertBanner
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        color: "#FFF",
        icon: "IconCross",
        size: 12
      }))));
    }
  }]);
  return SystemAlertBanner;
}(_react.Component);
SystemAlertBanner.propTypes = {
  currentUser: _propTypes["default"].object.isRequired,
  messageId: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = SystemAlertBanner;